import React, { useContext, useEffect } from "react";
import "./Blog_inner.css";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import { formatDate } from "../../../utils/common";
import { getblogById } from "../../features/blog/Slice";
import Back_text_holder from "../../common_components/back_text_holder/Back_text_holder";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/IDS";

function Blog_inner() {
  const { id } = useParams();
  const { language } = useContext(Context);

  // const blog = {
  //   image: "/assets/images/blogs/img1.jpg",
  //   name: "Is Store-Bought Honey Fake?",
  //   subname:
  //     "The Shocking Truth About What You're Buying. Think your honey is pure? You might want to look closer.",
  //   updatedAt: "2024-05-20T10:00:00Z",
  //   description:
  //     "Many honey brands use <strong>added syrups</strong> and fillers. Discover how to identify <em>pure, raw honey</em> versus processed alternatives in this guide. Many honey brands use <strong>added syrups</strong> and fillers. Discover how to identify <em>pure, raw honey</em> versus processed alternatives in this guide. Many honey brands use <strong>added syrups</strong> and fillers. Discover how to identify <em>pure, raw honey</em> versus processed alternatives in this guide. Many honey brands use <strong>added syrups</strong> and fillers. Discover how to identify <em>pure, raw honey</em> versus processed alternatives in this guide.",
  // };

  const allData = useSelector((state) => state?.blog?.blog?.blog);

  console.log(allData, "allData");

  // const blog = useSelector((state) => state.blog.blog);

  // const breadcrumbs = [
  //   { label: "Home", link: "/", isActive: false },
  //   { label: "BLOGS", link: "/blog", isActive: false },
  //   { label: blog?.name, link: "", isActive: true },
  // ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblogById({ id, language }));
  }, [dispatch, id, language]);

  return (
    <>
      <section className="Blog_inner">
        {/* <Breadcrumb_comp breadcrumbs={breadcrumbs} /> */}
        <div className="container">
          <div className="Blog_inner_holder">
            <div className="blog-content">
              <div className="float-image">
                <img
                  src={IDS?.IMG_URL + allData?.image}
                  alt="Blog_inner_img"
                  className="Blog_inner_img"
                />
              </div>

              <div className="content_div">
                <div className="text_holder">
                  <h4 className="heading_text">
                    {allData?.BlogLanguage?.name}
                  </h4>
                  <p className="submname">{allData?.BlogLanguage?.sub_title}</p>
                  <span className="date_text para_text">
                    {formatDate(allData?.updatedAt)}
                  </span>
                </div>

                <div className="text_holder">
                  <p className="para_text">
                    {parse(
                      typeof allData?.BlogLanguage?.description === "string"
                        ? allData.BlogLanguage?.description
                        : "",
                    )}
                  </p>
                </div>
              </div>
            </div>
            <Back_text_holder baseLink="/blogs" backText="Blog" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog_inner;
